import { createRouter, createWebHistory, START_LOCATION } from 'vue-router'
import store from '@/store'

//////////// ADMIN VUES ////////////
import AdminLogin from '../views/admin/AdminLoginPage.vue'

// Events
import AdminEvents from '../views/admin/AdminEventsPage.vue'
import AdminAddEvent from '../views/admin/AdminAddEventPage.vue'
import AdminViewEventBeneficiariesVolunteers from '../views/admin/AdminViewEventBeneficiariesVolunteersPage.vue'

// Beneficiaries
import AdminBeneficiaries from '../views/admin/AdminBeneficiariesPage.vue'
import AdminViewStory from '../views/admin/AdminViewStoryPage.vue'
import AdminApprovedBeneficiaries from '../views/admin/AdminApprovedBeneficiariesPage.vue'
import AdminDeclinedBeneficiaries from '../views/admin/AdminDeclinedBeneficiariesPage.vue'

// Volunteers
import AdminVolunteers from '../views/admin/AdminVolunteersPage.vue'
import AdminViewCvID from '../views/admin/AdminViewCvIdPage.vue'
import AdminApprovedVolunteers from '../views/admin/AdminApprovedVolunteersPage.vue'
import AdminDeclinedVolunteers from '../views/admin/AdminDeclinedVolunteersPage.vue'


//////////// VOLUNTEERS VUES ////////////
import VisitorHome from '../views/visitor/VisitorHomePage.vue'
import VisitorJoinUs from '../views/visitor/VisitorVolunteerApplicationPage.vue'
import VisitorApplyBeneficiary from '../views/visitor/VisitorBeneficiaryApplicationPage.vue'
import VisitorAskUs from '../views/visitor/VisitorAskUsPage.vue'
import VisitorAboutUs from '../views/visitor/VisitorAboutUsPage.vue'
import VisitorsTestimonials from '../views/visitor/VisitorTestimonialsPage.vue'
import VisitorDonate from '../views/visitor/VisitorDonatePage.vue'
import VisitorEventRegistration from '../views/visitor/VisitorEventRegistrationPage.vue'
import VisitorTimeline from '../views/visitor/VisitorTimelinePage.vue'

//////////// MISC VUES ////////////
import NotFound from '../views/NotFoundPage.vue'

const routes = [
    // Admin routes
    {
        path: '/login',
        name: 'TFYO | Admin Login',
        component: AdminLogin,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/events',
        name: 'TFYO | Admin Events',
        component: AdminEvents,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/events/view-beneficiaries-volunteers/:id',
        name: 'TFYO | Admin View Participants',
        component: AdminViewEventBeneficiariesVolunteers,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/add-event',
        name: 'TFYO | Admin Add Event',
        component: AdminAddEvent,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/beneficiaries',
        name: 'TFYO | Admin Beneficiaries',
        component: AdminBeneficiaries,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/beneficiaries/view-story/:id',
        name: 'TFYO | Beneficiary Story',
        component: AdminViewStory,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/volunteers',
        name: "TFYO | Admin Volunteers",
        component: AdminVolunteers,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/approved-volunteers',
        name: 'TFYO | Approved Volunteers',
        component: AdminApprovedVolunteers,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/declined-volunteers',
        name: 'TFYO | Declined Volunteers',
        component: AdminDeclinedVolunteers,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/volunteers/view-cvid/:id',
        name: 'TFYO | Volunteer CV/ID',
        component: AdminViewCvID,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/approved-beneficiaries',
        name: 'TFYO | Approved Beneficiaries',
        component: AdminApprovedBeneficiaries,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/declined-beneficiaries',
        name: 'TFYO | Declined Beneficiaries',
        component: AdminDeclinedBeneficiaries,
        meta: {
            requiresAuth: true
        }
    },


    // Visitor routes
    {
        path: '/',
        name: 'TFYO | Home',
        component: VisitorHome,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/register-event/:id?',
        name: 'TFYO | Event Registration',
        component: VisitorEventRegistration,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/apply-beneficiary',
        name: 'TFYO | Beneficiary Application',
        component: VisitorApplyBeneficiary,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/apply-volunteer/:id?',
        name: 'TFYO | Volunteer Application',
        component: VisitorJoinUs,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/ask-us',
        name: 'TFYO | Ask Us',
        component: VisitorAskUs,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/about-us',
        name: 'TFYO | About Us',
        component: VisitorAboutUs,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/testimonials',
        name: 'TFYO | Testimonials',
        component: VisitorsTestimonials,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/donate',
        name: 'TFYO | Donate',
        component: VisitorDonate,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/timeline',
        name: 'TFYO | Timeline',
        component: VisitorTimeline,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'TFYO | Page Not Found',
        component: NotFound,
        meta: {
            requiresAuth: false
        }
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { top: 0 }
    }   
})

router.beforeEach(async (to, from, next) => {
    document.title = to.name;

    let currentUser;
    // If reloaded, get current user again
    if (from === START_LOCATION) {
        await store.dispatch('auth/fetchUser').then(() => {
            currentUser = store.getters['auth/user']
        })
    } else {
        // Else, rely on store
        currentUser = store.getters['auth/user'];
    }

    if (currentUser === null) {
        if (to.meta.requiresAuth) {
            next('/login')
        } else {
            next()
        }
    } else {
        if (to.path === '/login') {
            next('/events')
        } else {
            next()
        }
    }
});

export default router